export default __webpack_public_path__ + "static/2-6bd15891e75c7403d31a2429033b35d8.jpg";